import * as React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from '../../../../common/form/Button';

interface Props {
    keyId: string;
    type: string;
    deleteKey: (keyIdToDelete: string) => Promise<void>;
}

const LatchKeyRow = (props: Props) => (
    <Row className="code-row">
        <Col>
            <span className="code-display">{props.keyId}</span>
        </Col>
        <Col md={2}>
            <span className="code-display">{props.type}</span>
        </Col>
        <Col md={2}>
            <Button
                text="Delete"
                addlClassName="btn-danger btn-sm"
                onClick={async () => {
                    await props.deleteKey(props.keyId);
                }}
            />
        </Col>
    </Row>
);

export default LatchKeyRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/LatchKeyRow.tsx